export const colors = {
  red: "#cf5757",
  redLight: "#e09090",
  greenLight: "#1cc492",
  green: "#0e9e72"
};
